import { render } from "./CreateUser.vue?vue&type=template&id=3bd371da&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import "./CreateUser.vue?vue&type=style&index=0&id=3bd371da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd371da"],['__file',"resources/assets/components/Users/CreateUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bd371da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bd371da', __exports__)) {
    api.reload('3bd371da', __exports__)
  }
  
  module.hot.accept("./CreateUser.vue?vue&type=template&id=3bd371da&scoped=true", () => {
    api.rerender('3bd371da', render)
  })

}


export default __exports__